
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.452 3.548C6.452 3.246 6.697 3 7 3h2a.548.548 0 110 1.097H7a.548.548 0 01-.548-.549zM8.065 13.161a.968.968 0 100-1.935.968.968 0 000 1.935z","fill":"#9DA7B2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.516 3.484A2.484 2.484 0 016 1h4a2.484 2.484 0 012.484 2.484v9.032A2.484 2.484 0 0110 15H6a2.484 2.484 0 01-2.484-2.484V3.484zM6 2.097c-.766 0-1.387.62-1.387 1.387v9.032c0 .766.621 1.387 1.387 1.387h4c.766 0 1.387-.62 1.387-1.387V3.484c0-.766-.62-1.387-1.387-1.387H6z","fill":"#9DA7B2"}})])
          )
        }
      }
    